import { Reveal } from "@/components/Reveal";
import { BadgeCheck, PiggyBank, Sparkles, Users } from "lucide-react";

const POINTS = [
  {
    n: "01",
    icon: BadgeCheck,
    title: "Professional & reliable",
    desc: "Turn up on time, do the job properly and treat your home with care — every single visit.",
  },
  {
    n: "02",
    icon: PiggyBank,
    title: "Affordable pricing",
    desc: "Honest, fair quotes with no hidden extras. Great results that don't cost the earth.",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Fresh, deep-cleaned results",
    desc: "Deep cleaning that lifts dirt from the fibres and leaves everything looking and smelling fresh.",
  },
  {
    n: "04",
    icon: Users,
    title: "Trusted by locals",
    desc: "A growing base of happy customers across Lanarkshire who come back and recommend us.",
  },
];

export const WhyChooseUs = () => (
  <section id="why" data-testid="why-section" className="relative overflow-hidden bg-navy py-20 sm:py-28 grain">
    <div className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-turquoise/20 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-turquoise">
          Why choose us
        </p>
        <h2 className="mt-3 font-display fluid-h2 font-semibold text-white">
          A cleaner you can{" "}
          <span className="italic text-turquoise">actually trust</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-px overflow-hidden rounded-3xl bg-white/10 sm:grid-cols-2">
        {POINTS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.08}>
            <div
              data-testid={`why-point-${i}`}
              className="group h-full bg-navy p-8 sm:p-10 transition-colors duration-500 hover:bg-navy-deep"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl text-white/15 transition-colors duration-500 group-hover:text-turquoise/60">
                  {p.n}
                </span>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-turquoise transition-all duration-500 group-hover:bg-turquoise group-hover:text-white">
                  <p.icon className="h-6 w-6" />
                </div>
              </div>
              <h3 className="mt-6 font-display text-2xl text-white">{p.title}</h3>
              <p className="mt-3 text-white/60 leading-relaxed">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
